import {
  httpGet,
  httpPost,
  httpPut,
  httpDelete,
  httpUploadFormData,
} from "../utils/http";

export default class {
  apiEndpoint = null;

  constructor(apiEndpoint) {
    this.apiEndpoint = apiEndpoint;
  }

  createReferral(referral, optUserID) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/referral?optUserID=${optUserID}`;

    return httpPost(apiUrl, referral);
  }

  deleteReferral(referralID) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/referral?referralID=${referralID}`;

    return httpDelete(apiUrl);
  }

  updateReferral(referralID, referral, optUserID) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/referral?referralID=${referralID}&optUserID=${optUserID}`;

    return httpPut(apiUrl, referral);
  }

  getReferralList(petID, clinic) {
    let clinicID = clinic ? clinic : localStorage.getItem("CLINIC");
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${clinicID}/referral/list?petID=${petID}`;
    return httpGet(apiUrl);
  }
}
